import { Table, Tag } from "antd";
import styled, { createGlobalStyle } from "styled-components";
export const GlobalMasterStyle = createGlobalStyle`
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    .ant-layout{
        background: transparent !important;
    }
    body{
        background: ${({ theme }) => theme.settings.whiteColor} !important;
        height: 100vh;
        font-family: ${({ theme }) => theme.fonts.inter} !important;
    }
    .bgWhite{
        background: ${({ theme }) => theme.settings.whiteColor} !important;
    }
    .bodyNoSidebar{
        background: #FCFCFF !important;
        height: 100vh;
        font-family: ${({ theme }) => theme.fonts.inter} !important; 
    }
`;
// new style
export const ThemeTable = styled(Table)`
  font-family: ${({ theme }) => theme.fonts.inter} !important;
  position: relative;
  background: transparent;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  border-radius: 10px;
  .ant-table {
    background: transparent;
    scrollbar-color: unset !important;
    ::-webkit-scrollbar {
      width: 2px;
    }
    ::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.settings.borderColor};
    }
    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.settings.primary};
    }
    ::-webkit-scrollbar-thumb:hover {
      background: ${({ theme }) => theme.settings.primary};
    }

    ::-webkit-scrollbar {
      height: 2px;
      width: 2px; /* width of vertical scrollbar */
      border: 1px solid ${({ theme }) => theme.settings.primary};
    }
  }
  .ant-table-cell {
    font-style: normal;
    font-weight: 500 !important;
    font-size: 12px;
    line-height: 16px;
    text-transform: capitalize;
    background: ${({ theme }) => theme.settings.bodyBg} !important;
    border-top: none !important;
    /* border-bottom: none !important; */
    color: ${({ theme }) => theme.settings.tertiary} !important;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    border-radius: 0px !important;
    a {
      font-family: ${({ theme }) => theme.fonts.inter} !important;
      color: ${({ theme }) => theme.settings.tertiary} !important;
      text-decoration: underline;
    }
    &:first-child {
      border-radius: 0px !important;
    }
    &:last-child {
      border-radius: 0px !important;
    }
  }
  th.ant-table-cell {
    font-weight: 500 !important;
    font-size: 12px;
    &:first-child {
      border-radius: 7px 0px 0px 0px !important;
    }
    &:last-child {
      border-radius: 0px 7px 0px 0px !important;
    }
  }
  td.ant-table-cell {
    text-transform: capitalize;
    font-weight: 400 !important;
    font-size: 12px;
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    color: ${({ theme }) => theme.settings.tertiary} !important;
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    &:first-child {
      border-radius: 0px !important;
    }
    &:last-child {
      border-radius: 0px !important;
    }
  }
  tr {
    &:last-child {
      td.ant-table-cell {
        &:first-child {
          border-radius: 0px 0px 0px 0px !important;
        }
        &:last-child {
          border-radius: 0px 0px 0px 0px !important;
        }
      }
    }
  }
  .ant-table-fixed-column {
    .ant-table {
      border-radius: 15px 15px 0px 0px !important;
    }
    tr {
      &:last-child {
        td.ant-table-cell {
          &:first-child {
            border-radius: 5px !important;
          }
          &:last-child {
            border-radius: 5px !important;
          }
        }
      }
    }
  }
  ul.ant-pagination {
    margin: 0px !important;
    padding: 15px !important;
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev {
      border-radius: 5px !important;
    }
    li.ant-pagination-item,
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev,
    .ant-pagination-prev button,
    .ant-pagination-next button {
      background: ${({ theme }) => theme.settings.whiteColor} !important;
      color: ${({ theme }) => theme.settings.primary} !important;
      border-radius: 50%;
      font-weight: 600;
      font-size: 12px;
      .ant-pagination-item-ellipsis {
        font-size: 8px !important;
        color: ${({ theme }) => theme.settings.tertiary} !important;
      }
      &:hover,
      &.ant-pagination-item-active {
        background: ${({ theme }) => theme.settings.primary} !important;
        color: ${({ theme }) => theme.settings.whiteColor} !important;
        border-color: transparent;
        .ant-pagination-item-link-icon {
          color: ${({ theme }) => theme.settings.whiteColor} !important;
        }
        a {
          color: ${({ theme }) => theme.settings.whiteColor} !important;
        }
      }
    }
    li.ant-pagination-disabled button {
      background: transparent;
      color: ${({ theme }) => theme.settings.borderColor};
      border-radius: 50%;
      font-weight: 600;
      font-size: 13px;
      &:hover {
        background: rgba(
          ${({ theme }) => theme.settings.textColor},
          1
        ) !important;
        color: ${({ theme }) => theme.settings.whiteColor} !important;
        border-color: ${({ theme }) => theme.settings.borderColor};
      }
    }
    .ant-select-selector {
      border-color: ${({ theme }) => theme.settings.borderColor} !important;
      font-size: 12px !important;
      line-height: 12px !important;
    }
  }
  .ant-checkbox-inner {
    border-color: ${({ theme }) => theme.settings.borderColor} !important;
    background: ${({ theme }) => theme.settings.bodyBg} !important;
  }
  .ant-checkbox-inner {
    &:after {
      border-color: ${({ theme }) => theme.settings.borderColor} !important;
    }
  }
  .ant-checkbox-indeterminate {
    .ant-checkbox-inner {
      &:after {
        background: ${({ theme }) => theme.settings.tertiary} !important;
      }
    }
  }
  th.ant-table-selection-column,
  td.ant-table-selection-column {
    padding-left: 20px !important;
  }
  &.noBorders {
    border: none !important;
  }
`;
// new style
export const ThemeTag = styled(Tag)`
  border-radius: 20px !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 18px !important;
  .ant-tag-close-icon {
    font-size: 12px !important;
    color: ${({ theme }) => theme.settings.primary} !important;
  }
`;
